import authHeader from "./auth-header";
import axios from "axios";
import { API_URL } from "./constants.service";

class InterestDataService {
  // Get all interests from the database
  getAll(filter) {
    return axios.post(API_URL + "/interests", filter, { headers: authHeader() });
  }

  // Create a new interest
  create(data) {
    return axios.post(API_URL + "/interest", data, { headers: authHeader() });
  }

  // Get just one interest
  get(id) {
    return axios.get(API_URL + `/interest/${id}`, { headers: authHeader() });
  }

  // Delete a specific interest out of the table.
  delete(id) {
    return axios.delete(API_URL + `/interest/${id}`, { headers: authHeader() });
  }

  // Update the data of one specific interest.
  update(id, data) {
    return axios.put(API_URL + `/interest/${id}`, data, {
      headers: authHeader(),
    });
  }

  getAllCurrent() {
    return axios.get(API_URL + "/interests", { headers: authHeader() });
  }
}

export default new InterestDataService();
